import * as React from 'react';
import { ElementRef, useRef } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { Recurrency, useGetRecurrencyQuery } from '../../graphql/types';
import RecurrencyAchDetails from './RecurrencyAchDetails';
import { DialogTitle } from '@mui/material';
import { Stack } from '@mui/system';
import RecurrencyTitle from './RecurrencyTitle';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export interface Props {
  open: boolean;
  handleDone: () => void;
  recurrencyId: string;
}

const RecurrencyAchDetailsDialog = ({ open, recurrencyId, handleDone }: Props) => {
  const achDetailsRef = useRef<ElementRef<typeof RecurrencyAchDetails>>(null);
  const { data } = useGetRecurrencyQuery({ variables: { id: recurrencyId }, fetchPolicy: 'network-only' });
  const recurrency: Recurrency = data?.recurrency as Recurrency;

  const AchStatusDialogTitle: React.FC<{ recurrency: Recurrency | null }> = () => {
    if (!recurrency) {
      return null;
    }
    return (
      <DialogTitle>
        <RecurrencyTitle recurrency={recurrency} />
      </DialogTitle>
    );
  };

  if (!recurrency) {
    return null;
  }

  return (
    <Dialog open={open} TransitionComponent={Transition} keepMounted onClose={handleDone} aria-describedby="alert-dialog-slide-description">
      <AchStatusDialogTitle recurrency={recurrency} />
      <DialogContent>
        <Stack pt={4}> </Stack>
        {open && <RecurrencyAchDetails recurrency={recurrency} ref={achDetailsRef} />}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDone} variant="contained">OK</Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecurrencyAchDetailsDialog;
